export function buildServerSideParams(tableState = {}) {
    const params = {
        page: tableState.page || 1,
        limit: tableState.perPage || 10,
    }

    if (tableState.searchTerm) {
        params.search = tableState.searchTerm
    }
    if (tableState.sortBy) {
        params.sortBy = tableState.sortBy
        params.sortOrder = tableState.sortOrder || "asc"
    }

    return params
}

export function extractRows(responseData) {
    if (!responseData) return []
    if (Array.isArray(responseData.result)) return responseData.result
    if (Array.isArray(responseData.data)) return responseData.data
    if (Array.isArray(responseData)) return responseData
    return []
}

export function extractTotalRows(responseData, rows, serverSide = false) {
    if (!serverSide) return rows.length
    const total = [
        responseData && responseData.totalResults,
        responseData && responseData.totalRecords,
        responseData && responseData.totalRows,
        responseData && responseData.total,
    ].find((value) => value !== undefined && value !== null)
    return total !== undefined ? total : rows.length
}
